import { Box } from '@mui/material';
import serviceCards from '#/components/pages/SuccessorDashboard/serviceCards';
import DashboardCard from '#/components/shared/dashboard-card';
import Extras from '#/components/pages/SuccessorDashboard/extras/extras';
import useLocales from '#/hooks/useLocales';
import useAccountSwitch from '#/hooks/useAccountSwitch';
import useServiceAccess from '#/lib/hooks/useServiceAccess';
import usePartner from '#/lib/hooks/usePartner';

export default function SServicesList() {
  const { translate } = useLocales();
  const { currentAccount } = useAccountSwitch();
  const { partnerKey } = usePartner();

  // Filter out services that should be hidden for 'pax' partner
  const filteredServiceCards =
    partnerKey === 'pax'
      ? serviceCards.filter(
          (card) =>
            !['assetsRegister', 'digitalFootprint', 'tax'].includes(
              card.accessKey as string
            )
        )
      : serviceCards;

  const serviceAccessKeys = filteredServiceCards.map(
    (service) => service.accessKey as string
  );

  const userReportedDead =
    currentAccount?.docs?.reported_as_dead_status === 'APPROVED';

  const accessResults = useServiceAccess({
    serviceAccessKeys,
    accessDetails: currentAccount?.invitation_details,
    userReportedDead,
  });

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
        gap: 2,
      }}
    >
      {filteredServiceCards.map((card, i) => (
        <DashboardCard
          title={card.title}
          icon={card.icon}
          description={card.description}
          key={`${card.title + i}`}
          tooltipTitle={
            currentAccount?.docs[card.serviceKey as string] === null
              ? translate('global.dashCardInfos.guest.noDocumentUploaded', {
                  hostName: `${currentAccount?.first_name} ${currentAccount?.last_name}`,
                  documentType: translate(
                    `global.dashCardInfos.${card.accessKey}.title`
                  ),
                })
              : !accessResults[card.accessKey as string]
              ? translate('global.dashCardInfos.guest.disabledButton')
              : undefined
          }
          showTooltip={!accessResults[card.accessKey as string]}
          noUploadYetRibbon={
            currentAccount?.docs[card.serviceKey as string] === null
          }
          actions={
            <Extras
              access={card.accessKey as string}
              serviceDoc={
                currentAccount?.docs
                  ? currentAccount?.docs[card.serviceKey as string]
                  : ''
              }
              {...card}
              ownerID={currentAccount?.id}
              disabled={
                !accessResults[card.accessKey as string] ||
                currentAccount?.docs[card.serviceKey as string] === null
              }
            />
          }
        />
      ))}
    </Box>
  );
}
